var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVolume(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.99 11.99V9.98999C12.09 9.98999 12.99 9.09999 12.99 7.98999C12.99 6.87999 12.1 5.98999 10.99 5.98999V3.98999C13.2 3.98999 14.99 5.77999 14.99 7.98999C14.99 10.2 13.2 11.99 10.99 11.99ZM18.98 7.98999C18.98 3.57999 15.4 0 10.99 0V2C14.3 2 16.98 4.67999 16.98 7.98999C16.98 11.3 14.3 13.98 10.99 13.98V15.98C15.4 15.98 18.98 12.4 18.98 7.98999ZM8.99001 0.5V15.48C8.99001 15.75 8.81999 15.83 8.62 15.65L3.37 10.99H0.5C0.23 10.99 0 10.77 0 10.49V5.5C0 5.23 0.22 5 0.5 5H3.37L8.62 0.339996C8.83 0.149996 8.99001 0.22 8.99001 0.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolume);
export default __webpack_public_path__ + "static/media/volume.f6913475.svg";
export { ForwardRef as ReactComponent };